import * as React from "react";
import { IDataCenter, IAdmin, IChangePassword } from "../../vm";
import {
  deleteDataCenterManager,
  getAllDataCenterManagers,
  updateDataCenterManagerPassword,
} from "../../services/datacenter/DataCenterManagerService";
import {
  IColumn,
  Stack,
  TooltipHost,
  IStackTokens,
  Text,
  PrimaryButton,
  DetailsListLayoutMode,
  SelectionMode,
  Fabric,
  DetailsList,
  Callout,
  DefaultButton,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  DirectionalHint,
  ITag,
} from "office-ui-fabric-react";
import Icon from "@mdi/react";
import {
  mdiDotsVertical,
  mdiFormTextboxPassword,
  mdiPencilOutline,
  mdiTrashCanOutline,
} from "@mdi/js";
import { THEME } from "../../utils/Styles";
import { Loading } from "../../services/Loading";
import ManageDataCenterManager from "./ManageDataCenterManager";
import NoDataTile from "../common/NoDataTile";
import { ToastContext } from "../common/ToastProvider";
import { ConfirmDialogContext } from "../common/ConfirmDialogProvider";
import { Formik, FormikErrors } from "formik";
import * as yup from "yup";
import { CustomTextField } from "../common/Library";
import PasswordPolicy from "../common/PasswordPolicy";
import { isValidPassword } from "../../services/UtilService";
import { childrenGap8 } from "../common/Constants";
import { getAllDataCenters } from "../../services/datacenter/DatacenterService";

// const changePasswordSchema = yup.object().shape({
//   newPassword: yup
//     .string()
//     .required('required')
//     .min(5, 'Needs to be more than 4 characters'),
//   // .length(5, "Needs to be more than 4 characters"),
// });

export interface DataCenterManagerMainProps {
  dataCenter: IDataCenter;
}

const DataCenterManagerMain: React.FC<DataCenterManagerMainProps> = ({
  dataCenter,
}) => {
  const [state, setState] = React.useState({
    dataCenterManagers: [],
    manageDataCenterManagerDialog: {
      isOpen: false,
      index: 1,
      data: undefined,
    },
    changePassword: {
      newPassword: undefined,
      userId: undefined,
    },
    updatePassword: {
      isOpen: false,
      element: undefined,
      userId: undefined,
    },
    isLoading: false,
    isDataLoaded: false,
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
  } as {
    dataCenterManagers: IAdmin[];
    manageDataCenterManagerDialog: {
      isOpen: boolean;
      index?: number;
      data?: IAdmin;
    };
    changePassword: IChangePassword;
    updatePassword: {
      isOpen: boolean;
      element: any;
      userId?: string;
    };
    isLoading: boolean;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IAdmin;
    };
  });
  const [datacenters, setDatacenters] = React.useState([] as ITag[]);

  React.useEffect(() => {
    const asyncFunc = async () => {
      setState({ ...state, isLoading: true });
      await getAllDataCenter();
      await getDataCenterManagers();
    };
    asyncFunc();
  }, []);

  //custom hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const wrapStackTokens: IStackTokens = { childrenGap: 16 };

  const getDataCenterManagers = async () => {
    // setState({ ...state, isLoading: true });
    let result = await getAllDataCenterManagers(dataCenter._id as string);
    if (result && result.success) {
      setState({ ...state, dataCenterManagers: result.data, isLoading: false });
    } else {
      showToast(
        result.message || "Error while getting Data Center Managers",
        "error"
      );
      setState({ ...state, isLoading: false });
    }
  };

  const getAllDataCenter = async () => {
    let result = await getAllDataCenters();
    if (result?.success) {
      let datacenters: ITag[] = [];
      result.data.forEach((d) => {
        datacenters.push({
          key: d._id as string,
          name: d.name,
        });
      });
      setDatacenters(datacenters);
    } else {
      showToast(result?.message || "Error while getting datacenters", "error");
    }
  };

  const handleManageDialogOpen = (isOpen: boolean, index?: number) => {
    let dataCenterManager = undefined;
    if (index !== undefined) {
      dataCenterManager = { ...state.dataCenterManagers[index] };
    }
    setState({
      ...state,
      manageDataCenterManagerDialog: {
        isOpen: isOpen,
        index: index,
        data: dataCenterManager,
      },
    });
  };

  const handleCloseManageDialog = (data: IAdmin) => {
    let dataCenterManagers = [...state.dataCenterManagers];
    if (data) {
      if (state.manageDataCenterManagerDialog.index !== undefined) {
        dataCenterManagers[state.manageDataCenterManagerDialog.index] = data;
      } else {
        dataCenterManagers.unshift(data);
      }
    }
    setState({
      ...state,
      manageDataCenterManagerDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      dataCenterManagers,
    });
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const deleteDm = (dataCenterManager: IAdmin, customerIndex: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete datacenter manager",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await deleteDataCenterManager(dataCenterManager);
        if (result.success) {
          showToast("Datacenter manager deleted successfully", "success");
          let dataCenterManagers = [...state.dataCenterManagers];
          dataCenterManagers.splice(customerIndex, 1);
          setState({
            ...state,
            dataCenterManagers,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting datacenter manager",
            "error"
          );
        }
      }
    );
  };

  const updatePassword = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    userId?: string
  ) => {
    setState({
      ...state,
      updatePassword: {
        isOpen,
        userId,
        element: isOpen ? ele?.currentTarget : undefined,
      },
    });
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color="#135c8a"
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content={"Edit Datacenter Manager"}
          //     id={`editDm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => handleManageDialogOpen(true, index)}>
          //       <Icon
          //         path={mdiPencilOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={"Change Password"}
          //     id={`cPDm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={(ele) => updatePassword(true, ele, item._id)}>
          //       <Icon
          //         path={mdiFormTextboxPassword}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.neutralPrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          //   &nbsp;&nbsp;
          //   <TooltipHost
          //     content={"Delete Datacenter Manager"}
          //     id={`deleteDm`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => deleteDm(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );

      case "isEnabled":
        return <span>{item.isEnabled ? "Yes" : "No"}</span>;
      case "name":
        return (
          <Text styles={{ root: { fontWeight: 600 } }}>
            {item[column.fieldName as any]}
          </Text>
        );
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const childrenGap24: IStackTokens = { childrenGap: 24 };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IAdmin
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
      updatePassword: {
        ...state.updatePassword,
        isOpen: false,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap24} className="pt-8">
        <Stack.Item>
          <Stack horizontal horizontalAlign="end">
            <Stack.Item>
              {/* <Text variant="xLarge">Datacenter Managers </Text> */}
            </Stack.Item>
            <Stack.Item>
              <PrimaryButton
                text="Add Datacenter Manager"
                onClick={() => handleManageDialogOpen(true)}
                className="borderless-btn bg-white"
              />
              {/* <PrimaryButton text="Add Customer Rack" onClick={() => this.handleAddDialogCustomerRackOpen(true)} /> */}
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <div>
            {state.dataCenterManagers && state.dataCenterManagers.length > 0 ? (
              <Fabric>
                <DetailsList
                  items={state.dataCenterManagers}
                  columns={[
                    {
                      key: "name",
                      name: "Name",
                      fieldName: "name",
                      minWidth: 200,
                      maxWidth: 400,
                      isResizable: true,
                    },
                    {
                      key: "email",
                      name: "Email",
                      fieldName: "email",
                      minWidth: 200,
                      maxWidth: 300,
                      isResizable: true,
                    },
                    {
                      key: "isEnabled",
                      name: "Is Enabled",
                      fieldName: "email",
                      minWidth: 200,
                      maxWidth: 300,
                      isResizable: true,
                    },
                    {
                      key: "actions",
                      name: "Actions",
                      fieldName: "actions",
                      minWidth: 200,
                      maxWidth: 200,
                      isResizable: true,
                    },
                  ]}
                  compact={true}
                  setKey="set"
                  onRenderItemColumn={_renderItemColumn as any}
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  onRenderRow={_onRenderRow}
                />
              </Fabric>
            ) : (
              <NoDataTile title="No Datacenter Managers Found"></NoDataTile>
            )}
          </div>
        </Stack.Item>
      </Stack>
      {state.manageDataCenterManagerDialog.isOpen && (
        <ManageDataCenterManager
          closeManageDialog={(data: IAdmin) => handleCloseManageDialog(data)}
          data={state.manageDataCenterManagerDialog.data}
          handleLoading={handleLoading}
          datacenterId={dataCenter._id as string}
          datacenters={datacenters}
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{
            root: {
              width: state.updatePassword.isOpen ? 300 : 180,
              padding: state.updatePassword.isOpen ? 5 : 20,
            },
          }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
          // setInitialFocus={true}
        >
          {state.updatePassword.isOpen ? (
            <Formik
              initialValues={state.changePassword}
              // validationSchema={changePasswordSchema}
              validate={(values: any) => {
                let errors: FormikErrors<{ newPassword?: string }> = {};

                if (
                  values.newPassword &&
                  !isValidPassword(values.newPassword, false)
                ) {
                  errors.newPassword = "Please enter valid password.";
                }

                return errors;
              }}
              onSubmit={async (values: IChangePassword, { setSubmitting }) => {
                let obj = { ...values };
                obj.userId = state.updatePassword.userId;
                let result;
                handleLoading();
                result = await updateDataCenterManagerPassword(
                  obj.userId as string,
                  obj.newPassword as string
                );
                handleLoading();
                updatePassword(false);
                handleCallOutOpenClose(false);
                if (result.success) {
                  showToast("Password updated successfully", "success");
                } else {
                  showToast(
                    result.message || "Error while updating password",
                    "error"
                  );
                }
                setSubmitting(false);
              }}
            >
              {({ handleSubmit, errors, touched, values }) => (
                <form onSubmit={handleSubmit}>
                  <Stack
                    wrap
                    tokens={wrapStackTokens}
                    styles={{ root: { padding: "10px" } }}
                  >
                    <Stack.Item>
                      <CustomTextField
                        name={"newPassword"}
                        type="password"
                        label={"Update Password"}
                        placeholder="Enter new password"
                      />
                    </Stack.Item>
                    {errors.newPassword &&
                      touched.newPassword &&
                      values.newPassword && (
                        <Stack.Item>
                          <PasswordPolicy password={values.newPassword} isAdmin={false} />
                        </Stack.Item>
                      )}
                    <Stack.Item align="end">
                      <DefaultButton
                        text="Cancel"
                        onClick={() => {
                          handleCallOutOpenClose(false);
                        }}
                        className="borderless-btn"
                      />
                      &nbsp;&nbsp;
                      <PrimaryButton text="Update" type="submit" />
                    </Stack.Item>
                  </Stack>
                </form>
              )}
            </Formik>
          ) : (
            <Stack tokens={childrenGap8}>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    handleManageDialogOpen(
                      true,
                      state.manageActionsCallout.index
                    );
                  }}
                  className="callout-options"
                >
                  Edit
                </span>
              </Stack.Item>
              <Stack.Item className="pointer">
                <span
                  onClick={
                    () =>
                      setState({
                        ...state,
                        updatePassword: {
                          ...state.updatePassword,
                          isOpen: true,
                          userId: state.manageActionsCallout.data
                            ?._id as string,
                        },
                      })
                    // updatePassword(
                    //   true,
                    //   state.manageActionsCallout.element,
                    //   state.manageActionsCallout.data?._id as string,
                    //   state.manageActionsCallout.data?.role
                    // )
                  }
                  className="callout-options"
                >
                  Update Password
                </span>
              </Stack.Item>
              <Stack.Item className="pointer">
                <span
                  onClick={() => {
                    deleteDm(
                      state.manageActionsCallout.data as IAdmin,
                      state.manageActionsCallout.index as number
                    );
                  }}
                  className="callout-options"
                >
                  Delete
                </span>
              </Stack.Item>
            </Stack>
          )}
        </Callout>
      )}
      {/* {state.updatePassword.isOpen && (
        <Callout
          styles={{ root: { width: 300 } }}
          role="alert-dialog"
          ariaLabelledBy={state.updatePassword && state.updatePassword.userId}
          target={state.updatePassword.element}
          className="ms-CalloutExample-callout"
          gapSpace={0}
          onDismiss={() => updatePassword(false)}
          // setInitialFocus={true}
        >
          <Formik
            initialValues={state.changePassword}
            // validationSchema={changePasswordSchema}
            validate={(values: any) => {
              let errors: FormikErrors<{ newPassword?: string }> = {};

              if (values.newPassword && !isValidPassword(values.newPassword)) {
                errors.newPassword = "Please enter valid password.";
              }

              return errors;
            }}
            onSubmit={async (values: IChangePassword, { setSubmitting }) => {
              let obj = { ...values };
              obj.userId = state.updatePassword.userId;
              let result;
              handleLoading();
              result = await updateDataCenterManagerPassword(
                obj.userId as string,
                obj.newPassword as string
              );
              handleLoading();
              updatePassword(false);
              if (result.success) {
                showToast("Password updated successfully", "success");
              } else {
                showToast(
                  result.message || "Error while updating password",
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({ handleSubmit, errors, touched, values }) => (
              <form onSubmit={handleSubmit}>
                <Stack
                  wrap
                  tokens={wrapStackTokens}
                  styles={{ root: { padding: "10px" } }}
                >
                  <Stack.Item>
                    <CustomTextField
                      name={"newPassword"}
                      type="password"
                      label={"Update Password"}
                      placeholder="Enter new password"
                    />
                  </Stack.Item>
                  {errors.newPassword &&
                    touched.newPassword &&
                    values.newPassword && (
                      <Stack.Item>
                        <PasswordPolicy password={values.newPassword} />
                      </Stack.Item>
                    )}
                  <Stack.Item align="end">
                    <DefaultButton
                      text="Cancel"
                      onClick={() => {
                        updatePassword(false);
                      }}
                    />
                    &nbsp;&nbsp;
                    <PrimaryButton text="Update" type="submit" />
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Callout>
      )} */}
    </React.Fragment>
  );
};

export default DataCenterManagerMain;
